import { FindOrCreateForRepostResponse as DraftData } from 'je-bff/src/jobs/drafts/findOrCreateDraftForRepost';
import { ClientError } from '@common/helpers/errors';
import { trpcBff } from '@trpcBff';

export type UseFindRecentDraftProps = {
  repostJobId: string;
  forceNewDraft: boolean;
};
export type FindOrCreateDraftJob = DraftData;

export type FindOrCreateDraftResponse = {
  data: FindOrCreateDraftJob;
  isLoading: boolean;
  isFetched: boolean;
  isError: boolean;
  error?: ClientError;
};

export const useFindOrCreateDraftForRepost = ({
  repostJobId,
  forceNewDraft
}: UseFindRecentDraftProps): FindOrCreateDraftResponse => {
  const params = { repostJobId, forceNewDraft };

  const { data, isError, isFetched, isLoading, error } =
    trpcBff.jobs.drafts.findOrCreateDraftForRepost.useQuery(params, {
      staleTime: 10000,
      retry: false
    });

  return {
    data,
    isLoading,
    isFetched,
    isError,
    error: getClientError(error)
  };
};

const getClientError = (errorProperties) => {
  if (!errorProperties) return;

  return new ClientError('errors.defaultWithGuid', {
    guid: errorProperties.guid,
    responseBody: errorProperties.responseBody
  });
};
